import { useState, type Dispatch, type SetStateAction } from 'react';
import { Outlet } from 'react-router-dom';
import ToolsBreadcrumb from '@/app/common/components/ToolsBreadcrumb';

type BreadcrumbItem = { text: string; href: string };

type SupportOutletContext = [
  BreadcrumbItem[],
  Dispatch<SetStateAction<BreadcrumbItem[]>>
];

const Support = () => {
  const [breadcrumbData, setBreadcrumbData] = useState<BreadcrumbItem[]>([]);

  return (
    <>
      <ToolsBreadcrumb
        parentName="پشتیبانی"
        parentUrl={`/support/mentoring`}
        childs={breadcrumbData}
      />
      <Outlet
        context={
          [breadcrumbData, setBreadcrumbData] satisfies SupportOutletContext
        }
      />
    </>
  );
};

export default Support;
